<template>
<svg xmlns="http://www.w3.org/2000/svg" class="landing__logo" viewBox="0 0 640 420">
  <title>logo_vis</title>
  <path d="M99.4,132.78a36.47,36.47,0,0,1-11.86-10.15,23.74,23.74,0,0,1-4.62-14.78,23,23,0,0,1,4.92-14.78,32.43,32.43,0,0,1,13.88-9.65,55.67,55.67,0,0,1,19.8-3.32,47.68,47.68,0,0,1,19.11,3.62A30.48,30.48,0,0,1,153.8,94.28c3.21,4.62,4.72,10.15,4.72,16.49H133.39a10.47,10.47,0,0,0-3.22-8c-2.11-2-5.23-2.91-9.25-2.91A20.2,20.2,0,0,0,114,101a11.42,11.42,0,0,0-4.42,3,6.3,6.3,0,0,0-1.51,4.12c0,2.51,1.41,4.63,4.32,6.34A68.47,68.47,0,0,0,125.55,120c10.85,3.51,19.1,7.84,24.63,13.07s8.34,11.86,8.34,20A25.16,25.16,0,0,1,154,168.27a27.79,27.79,0,0,1-12.77,9.56c-5.53,2.21-12,3.21-19.4,3.21a56.81,56.81,0,0,1-20.41-3.62,35.16,35.16,0,0,1-15.49-11.36C82,160.94,80,154.5,80,146.76h25.34a17.55,17.55,0,0,0,1.81,8.65,10.21,10.21,0,0,0,5.32,4.52,26.69,26.69,0,0,0,9.25,1.31c3.93,0,6.84-.81,8.65-2.32a6.94,6.94,0,0,0,2.82-5.73,9.42,9.42,0,0,0-1.21-4.92,12.8,12.8,0,0,0-4.73-3.92A75.75,75.75,0,0,0,116.7,140,92.87,92.87,0,0,1,99.4,132.78Z"
    style="fill:#f14f1d" />
  <path d="M274.55,179.84H249.31v-18.6l2.41-50.07L229.1,179.74H212.61L190,111.17l2.52,50.07v18.6H167.17V81.41h33.18l20.51,65.35,20.51-65.35h33.28l-.1,98.43Z"
    style="fill:#f14f1d" />
  <path d="M344.12,163.55H312.45l-5,16.29H280.28l36-98.43H340.2l36.09,98.43H349.15Zm-6.23-20.41-9.55-31.07-9.56,31.07Z" style="fill:#f14f1d"
  />
  <path d="M395.7,132.78a36.41,36.41,0,0,1-11.87-10.15,23.8,23.8,0,0,1-4.62-14.78,23,23,0,0,1,4.93-14.78,31,31,0,0,1,13.77-9.65A55.69,55.69,0,0,1,417.72,80a47.63,47.63,0,0,1,19.1,3.62A30.48,30.48,0,0,1,450,94.18c3.22,4.62,4.73,10.15,4.73,16.48H429.58a10.46,10.46,0,0,0-3.22-7.94c-2.11-2-5.22-2.91-9.25-2.91a20.14,20.14,0,0,0-6.93,1.1,11.54,11.54,0,0,0-4.43,3,6.35,6.35,0,0,0-1.51,4.12c0,2.51,1.41,4.63,4.33,6.33a67.69,67.69,0,0,0,13.17,5.53c10.86,3.52,19.1,7.85,24.63,13.08s8.35,11.86,8.35,20a25.12,25.12,0,0,1-4.53,15.18,27.74,27.74,0,0,1-12.77,9.56c-5.53,2.21-12,3.21-19.4,3.21a56.81,56.81,0,0,1-20.41-3.62A35.13,35.13,0,0,1,382.13,166c-3.93-5.13-5.94-11.56-5.94-19.3h25.34a17.55,17.55,0,0,0,1.81,8.65,10.31,10.31,0,0,0,5.33,4.52,26.65,26.65,0,0,0,9.25,1.31c3.92,0,6.83-.81,8.64-2.32a6.94,6.94,0,0,0,2.82-5.73,9.32,9.32,0,0,0-1.21-4.92,12.84,12.84,0,0,0-4.72-3.92,76,76,0,0,0-10.56-4.33A85.53,85.53,0,0,1,395.7,132.78Z"
    style="fill:#f14f1d" />
  <path d="M546.11,81.41v98.43H521V139.92H488.1v39.92H462.86V81.41H488.1v38.2H521V81.41Z" style="fill:#f14f1d" />
  <path d="M135.9,206.38a43.37,43.37,0,0,1,16.39,16.89,50.49,50.49,0,0,1,5.93,24.43v3.72a49.77,49.77,0,0,1-5.83,24.33,44.25,44.25,0,0,1-16.19,16.89A45.43,45.43,0,0,1,113,298.78H80V200.35h32.27A44.53,44.53,0,0,1,135.9,206.38Zm-3.52,41.12c0-8.85-1.71-15.48-5.13-20s-8.44-6.83-15-6.83h-7v57.71h7.54c6.23,0,11.06-2.21,14.47-6.74s5-11.26,5-20.21l.1-3.92Z"
    style="fill:#f14f1d" />
  <path d="M403.54,278.37v20.31H337.79V200.25H363v78.12Z" style="fill:#f14f1d" />
  <path d="M470.8,220.66H441.44v78H416.21v-78H387.66V200.25H470.9l-.1,20.41Z" style="fill:#f14f1d" />
  <path d="M520.57,282.39H488.9l-5,16.29H456.73l35.89-98.43h23.93l36.09,98.43H525.5ZM514.34,262l-9.55-31.07L495.23,262Z"
    style="fill:#f14f1d" />
  <rect x="167.17" y="200.25" width="159.56" height="20.41" style="fill:#f14f1d" />
  <rect x="167.17" y="278.37" width="159.56" height="20.41" style="fill:#f14f1d" />
  <rect x="167.17" y="239.26" width="159.56" height="20.41" style="fill:#f14f1d" />
  <g style="isolation:isolate">
    <path d="M100.25,333.7v5.91H81V311h7.38V333.7Z" style="fill:#f14f1d" />
    <path d="M243.81,334.87h-9.25l-1.47,4.74h-7.93L235.66,311h7l10.56,28.59h-7.95ZM242,328.94l-2.81-9-2.78,9Z" style="fill:#f14f1d"
    />
    <path d="M400.56,327.37a6.56,6.56,0,0,1,1.09,3.71q0,8.54-11,8.53H379V311h10.46q5.55,0,8.6,2a6.68,6.68,0,0,1,3.05,6,7.4,7.4,0,0,1-.93,3.73,5.55,5.55,0,0,1-3,2.41A5.53,5.53,0,0,1,400.56,327.37ZM386.32,317v5.95h3a6.27,6.27,0,0,0,3.36-.67,2.44,2.44,0,0,0,1-2.16,2.78,2.78,0,0,0-1-2.4,5.72,5.72,0,0,0-3.26-.72Zm7.09,16a2.5,2.5,0,0,0,.88-2c0-2.1-1.12-3.14-3.36-3.14h-4.61v5.89h4.31A4.1,4.1,0,0,0,393.41,332.92Z"
      style="fill:#f14f1d" />
    <path d="M534,326a10.64,10.64,0,0,1-3.48-2.94,6.92,6.92,0,0,1-1.35-4.3,6.69,6.69,0,0,1,1.45-4.3,9.19,9.19,0,0,1,4-2.8,16,16,0,0,1,5.79-1,14.12,14.12,0,0,1,5.6,1.06,8.79,8.79,0,0,1,3.84,3.08,8.21,8.21,0,0,1,1.4,4.8h-7.36a3,3,0,0,0-.94-2.31,3.89,3.89,0,0,0-2.72-.85,5.57,5.57,0,0,0-2,.33,3,3,0,0,0-1.29.87,1.85,1.85,0,0,0-.43,1.19,2.2,2.2,0,0,0,1.25,1.85,19.14,19.14,0,0,0,3.85,1.61,19,19,0,0,1,7.21,3.81,7.62,7.62,0,0,1,2.44,5.81,7.29,7.29,0,0,1-1.33,4.42,8.13,8.13,0,0,1-3.73,2.77,15.54,15.54,0,0,1-5.68.94,16.71,16.71,0,0,1-6-1.05,10.17,10.17,0,0,1-4.52-3.29A8.87,8.87,0,0,1,528.3,330h7.42a5.14,5.14,0,0,0,.52,2.52,2.86,2.86,0,0,0,1.57,1.3,7.89,7.89,0,0,0,2.71.39,4,4,0,0,0,2.54-.68,2.07,2.07,0,0,0,.82-1.66,2.72,2.72,0,0,0-.35-1.42,3.63,3.63,0,0,0-1.4-1.15,19.91,19.91,0,0,0-3.09-1.26A31.06,31.06,0,0,1,534,326Z"
      style="fill:#f14f1d" />
  </g>
  <transition name="arrowfade">
    <g v-show="currentView === 'landing'">
      <line x1="316.32" y1="360" x2="316.32" y2="380" style="fill:none;stroke:#f14f1d;stroke-miterlimit:10;stroke-width:2px"/>
      <polyline points="326.32 370 316.32 380 306.32 370" style="fill:none;stroke:#f14f1d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px" />    
    </g>
  </transition>
</svg>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([ 'currentView' ])
  }
}
</script>


<style scoped>

.tagline {
  font-weight: 900;
  font-family: 'Heebo';
  text-transform: uppercase;
}

#logo {
  fill: #F14F1D;
  stroke: #F14F1D;
}

.scroll {
  opacity: 0;
  transition: opacity .5s;
  transition-delay: .5s;
}.scroll--landing {
  opacity: 1;
}

.arrowfade-enter {
  opacity: 0;
}.arrowfade-enter-active {
  transition: opacity .5s;
  transition-delay: .3s;
}.arrowfade-enter-to {
  opacity: 1;
}.arrowfade-leave-to {
  opacity: 0;
}

</style>
